export default __webpack_public_path__ + "static/media/righteye.89acdf33.svg";